import React, { Suspense, lazy, useEffect, useState } from "react";
import Masterlayout from "./layouts/admin/Masterlayout";
import { createBrowserHistory } from "history";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  HashRouter,
} from "react-router-dom";
import Page403 from "../src/components/Errors/Page403";
import Page404 from "../src/components/Errors/Page404";
import { Provider } from 'react-redux';
import store from './store/store';

import Login from "./components/frontend/auth/Login";
import Register from "./components/frontend/auth/Register";
import AdminLogin from "./components/admin/Auth/AdminLogin";
import AdminPrivateRoute from "../src/AdminPrivateRoute";
import PublicRoute from "../src/PublicRoute";
import About from "../src/components/frontend/About";
import Contact from "../src/components/frontend/Contact";
import Home from "../src/components/frontend/Home";
import axios from "axios";
import { applyStoreFavicon, applyStoreTitle } from "./util/storeLogoHelper";
import { loadStoreSettings } from "./util/storeSettings";
import { restoreCustomerSession } from "./util/customerAuth";
import ThemeDemoPage from "./components/frontend/ThemeDemoPage";


import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'

// GrowCart platform panel (staff only, served on the platform host). Loaded on demand,
// so storefront visitors never download it.
const PlatformApp = lazy(() => import("./platform/PlatformApp"));

export const imageurl =
  process.env.REACT_APP_IMAGE_BASE_URL !== undefined
    ? process.env.REACT_APP_IMAGE_BASE_URL
    : (process.env.REACT_APP_API_BASE_URL !== undefined
        ? process.env.REACT_APP_API_BASE_URL
        : "http://localhost:8000");

axios.interceptors.request.use(function (config) {
  const token = sessionStorage.getItem("auth_token");
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  if (typeof FormData !== "undefined" && config.data instanceof FormData && config.headers) {
    delete config.headers["Content-Type"];
    delete config.headers["content-type"];
  }
  return config;
});

function App() {
  let persistor = persistStore(store);
  const history = createBrowserHistory();

  const configuredApiBase = process.env.REACT_APP_API_BASE_URL;
  axios.defaults.baseURL =
    configuredApiBase === undefined
      ? "http://localhost:8000"
      : (String(configuredApiBase).replace(/\/$/, "") || "/");

  axios.defaults.headers.post["Content-Type"] = "application/json";
  axios.defaults.headers.post["Accept"] = "application/json";
  // CSRF Generate
  axios.defaults.withCredentials = true;

  useEffect(() => {
    // The platform panel has no store settings to load.
    if (window.location.pathname.startsWith("/platform")) return undefined;
    restoreCustomerSession();
    let mounted = true;
    loadStoreSettings()
      .then((settings) => {
        if (!mounted || !settings) return;
        applyStoreFavicon(settings);
        applyStoreTitle(settings);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>

          <Router history={history}>
            <Switch>
              {/* LOGIN PROTECTED ROUTE */}

              {/* <Route path="/login">
            {localStorage.getItem("auth_token") ? (
              <Redirect to="/" />
            ) : (
              <Login />
            )}
          </Route> */}

              {/* REGISTER PROTECTED ROUTE */}

              {/* <Route path="/register">
            {localStorage.getItem("auth_token") ? (
              <Redirect to="/" />
            ) : (
              <Register />
            )}
          </Route> */}

              {/* Staff sign in. Shoppers use /login inside the store. */}
              <Route exact path="/admin/login" component={AdminLogin} />

              {/* Truthful theme demo rendered from the same storefront components. */}
              <Route exact path="/theme-demo/:themeKey" component={ThemeDemoPage} />

              {/* GROWCART PLATFORM PANEL */}
              <Route path="/platform">
                <Suspense fallback={null}>
                  <PlatformApp />
                </Suspense>
              </Route>

              {/* ADMIN PRIVATE ROUTES */}
              <AdminPrivateRoute path="/admin" name="Admin" />

              {/* PUBLIC STOREFRONT (GUEST-BASED) */}
              <PublicRoute path="/" name="Home" />
            </Switch>
          </Router>

        </PersistGate>
      </Provider>

    </div>
  );
}

export default App;
